import type { PropsWithChildren } from 'react';

import styles from './ApplicationScoreOverview.module.scss';

export const ApplicationScoreOverview = ({ children }: PropsWithChildren) => {
  return <div className={styles.container}>{children}</div>;
};

ApplicationScoreOverview.Title = ({ children }: PropsWithChildren) => (
  <span className={styles.title}>{children}</span>
);

ApplicationScoreOverview.Score = ({ children }: PropsWithChildren) => (
  <div className={styles.score}>{children}</div>
);

ApplicationScoreOverview.Controls = ({ children }: PropsWithChildren) => (
  <div className={styles.controls}>{children}</div>
);

ApplicationScoreOverview.Details = ({ children }: PropsWithChildren) => (
  <div className={styles.details}>{children}</div>
);
